import ReleaseOne from "./images/releases/1.jpg";
import ReleaseTwo from "./images/releases/2.jpg";
import ReleaseThree from "./images/releases/3.jpg";
import ReleaseFour from "./images/releases/4.jpg";

const releaseArtwork = (src) => ({
  thumb_small: src,
  thumb_medium: src,
});

const mockDisputeClaimsData = [
  {
    id: 1101,
    release: 1,
    release_name: "Echoing Silhouette",
    release_artwork: releaseArtwork(ReleaseOne),
    release_owner: "Demo Subuser",
    sub_user: 201,
    store: "Spotify",
    claimant_name: "Rights Holder LLC",
    claimant_email: "claims@example-rights.test",
    resolution_time: "30 days",
    time_remaining: "12 days",
    status: "in_progress",
    created: "2026-04-18T11:45:00Z",
  },
  {
    id: 1102,
    release: 2,
    release_name: "Serene Legacy",
    release_artwork: releaseArtwork(ReleaseTwo),
    release_owner: "Catalog Team",
    sub_user: 202,
    store: "Apple Music",
    claimant_name: "Indie Publishing Group",
    claimant_email: "legal@indie-publishing.test",
    resolution_time: "45 days",
    time_remaining: "28 days",
    status: "pending",
    created: "2026-04-10T09:20:00Z",
  },
  {
    id: 1103,
    release: 3,
    release_name: "Midnight Frequencies",
    release_artwork: releaseArtwork(ReleaseThree),
    release_owner: "Demo Admin",
    store: "YouTube Music",
    claimant_name: "Content ID Services",
    claimant_email: "notices@content-id.test",
    resolution_time: "14 days",
    time_remaining: "3 days",
    status: "created",
    created: "2026-05-01T14:00:00Z",
  },
  {
    id: 1104,
    release: 4,
    release_name: "Neon Drift",
    release_artwork: releaseArtwork(ReleaseFour),
    release_owner: "Demo Subuser",
    store: "Amazon Music",
    claimant_name: "Legacy Label Partners",
    claimant_email: "disputes@legacy-label.test",
    resolution_time: "60 days",
    time_remaining: "0 days",
    status: "resolved",
    created: "2026-02-22T08:15:00Z",
  },
  {
    id: 1105,
    release: 1,
    release_name: "Echoing Silhouette",
    release_artwork: releaseArtwork(ReleaseOne),
    release_owner: "Catalog Team",
    store: "Deezer",
    claimant_name: "Global Rights Bureau",
    claimant_email: "enforcement@global-rights.test",
    resolution_time: "30 days",
    time_remaining: "—",
    status: "copyright_violation",
    created: "2026-01-05T16:30:00Z",
  },
];

export default mockDisputeClaimsData;
